var map = {
	"./1/symbol_0.png": "a131",
	"./1/symbol_1.png": "2ef0",
	"./1/symbol_10.png": "a38c",
	"./1/symbol_11.png": "5ae1",
	"./1/symbol_12.png": "313a",
	"./1/symbol_13_x10.png": "9444",
	"./1/symbol_13_x100.png": "9a06",
	"./1/symbol_13_x1000.png": "0133",
	"./1/symbol_13_x12.png": "855a",
	"./1/symbol_13_x15.png": "3467",
	"./1/symbol_13_x2.png": "4140",
	"./1/symbol_13_x20.png": "8197",
	"./1/symbol_13_x25.png": "5ce9",
	"./1/symbol_13_x3.png": "9a60",
	"./1/symbol_13_x4.png": "bbad",
	"./1/symbol_13_x5.png": "8eac",
	"./1/symbol_13_x50.png": "4c69",
	"./1/symbol_13_x6.png": "97d5",
	"./1/symbol_13_x8.png": "8e60b",
	"./1/symbol_2.png": "dc10",
	"./1/symbol_3.png": "5862",
	"./1/symbol_4.png": "616d",
	"./1/symbol_5.png": "81ea",
	"./1/symbol_6.png": "7d69",
	"./1/symbol_7.png": "de11",
	"./1/symbol_8.png": "f389",
	"./1/symbol_9.png": "79a8",
	"./2/symbol_0.png": "18a5",
	"./2/symbol_1.png": "1c58",
	"./2/symbol_10.png": "df02",
	"./2/symbol_11.png": "9499",
	"./2/symbol_12.png": "ac86e",
	"./2/symbol_2.png": "a1c5",
	"./2/symbol_3.png": "220f",
	"./2/symbol_4.png": "fc83",
	"./2/symbol_5.png": "86b6",
	"./2/symbol_6.png": "27c1",
	"./2/symbol_7.png": "3c00",
	"./2/symbol_8.png": "dd28",
	"./2/symbol_9.png": "b7ef",
	"./3/symbol_0.png": "9d9b",
	"./3/symbol_1.png": "97ef",
	"./3/symbol_10.png": "d993",
	"./3/symbol_12.png": "cf0c",
	"./3/symbol_2.png": "e210",
	"./3/symbol_3.png": "236d",
	"./3/symbol_4.png": "ad52",
	"./3/symbol_5.png": "a3bd",
	"./3/symbol_6.png": "d7d0",
	"./3/symbol_7.png": "e9fb",
	"./3/symbol_8.png": "324f",
	"./3/symbol_9.png": "52bd9",
	"./4/symbol_0.png": "5d0a",
	"./4/symbol_1.png": "ffd4",
	"./4/symbol_10.png": "c92b",
	"./4/symbol_12.png": "7757",
	"./4/symbol_2.png": "20f3",
	"./4/symbol_3.png": "bb96",
	"./4/symbol_4.png": "ea9e",
	"./4/symbol_5.png": "e8c1",
	"./4/symbol_6.png": "b309",
	"./4/symbol_7.png": "15cc",
	"./4/symbol_8.png": "98d9",
	"./4/symbol_9.png": "d68e",
	"./gold1.png": "4add",
	"./gold2.png": "501d",
	"./gold3.png": "76d7",
	"./gold4.png": "43b6",
	"./silver1.png": "2c29",
	"./silver2.png": "34c8",
	"./silver3.png": "ffd2",
	"./silver4.png": "a442"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0123";